import { createSlice } from '@reduxjs/toolkit';

const notificationsSlice = createSlice({
  name: 'notifications',
  initialState: {
    notification: null,
    duration: 5000,
  },
  reducers: {
    showNotification(state, action) {
      state.notification = action.payload;
    },
    clearNotification(state, _) {
      state.notification = null;
    },
  },
  selectors: {
    getNotification: state => state.notification,
  },
});
export const reducer = notificationsSlice.reducer;
export const {
  showNotification,
  clearNotification,
} = notificationsSlice.actions;
export const { getNotification } = notificationsSlice.selectors;
